import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.WidgetService = function () {

};

HSN.Service.WidgetService.prototype =
{
    RefreshWidget: function (url, data, config) {
        this._sendHtml(url, data, config);
    },

    ShowGlobalMessaging: function(data, config) {
        this._sendHtml('/global-messaging/show', data, config);
    },

    GetNamedCell: function(url, data, config) {
        this._sendHtml(url, data, config);
    },

    _sendHtml: function (url, data, config) {
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                cache: (config.cacheable = config.cacheable || false),
                type: 'GET',
                data: data,
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), true, data);
                },
                error: function (xhr, status, error) {
                    if (config.callback)
                        config.callback.call((config.scope || config.callback), false, error);
                }
            }
        );
    },
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Service/WidgetService.js